export const CsFlag = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_18761_106422)">
        <g clipPath="url(#clip1_18761_106422)">
          <path
            d="M20 10.0029V18.419C19.999 18.8379 19.8828 19.2392 19.6767 19.5354C19.4707 19.8316 19.1915 19.9986 18.9001 20.0001H1.09984C0.808456 19.9986 0.529303 19.8316 0.323265 19.5354C0.117226 19.2392 0.00102018 18.8379 -7.62939e-06 18.419L-7.62939e-06 10.0029H20Z"
            fill="#D7141A"
          />
          <path
            d="M20 10.0028H0V1.58116C0.00102781 1.16227 0.117234 0.760949 0.323272 0.464744C0.529311 0.168538 0.808464 0.0014776 1.09984 0L18.9002 0C19.1915 0.0014776 19.4707 0.168538 19.6767 0.464744C19.8828 0.760949 19.999 1.16227 20 1.58116V10.0028Z"
            fill="white"
          />
          <path
            d="M11 10L0.222301 0.628174C0.0818956 0.897308 -7.62939e-06 1.22251 -7.62939e-06 1.58136V18.419C-7.62939e-06 18.7779 0.0818956 19.1087 0.222301 19.3722L11 10Z"
            fill="#11457E"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18761_106422">
          <rect
            width="20"
            height="20"
            rx="10"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_18761_106422">
          <rect
            width="20"
            height="20"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
